import React from 'react'
import {
  Card,
  CardMedia,
  CardTitle,
  CardText,
  CardActions
} from 'material-ui/Card'
import { Button } from 'components'
import { Enum, AnalyticsUtils } from 'utils'

const JOB_TYPE = "SEO Problems"

export default class SEOFixesCard extends React.Component {
  static propTypes = {
    source: React.PropTypes.string
  }

  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired
  }

  componentDidMount() {
    AnalyticsUtils.recommendedJobViewed(JOB_TYPE)
  }

  render() {
    return (
      <Card key='seofixes' className='recommended-job-card' style={{borderRadius: 10}} onTouchTap={ () => { location.href = 'https://www.blimpon.com/pages/compare-seo-fix-packages' } }>
        <CardMedia>
          <img src='https://dropshare-daniel.s3-eu-west-1.amazonaws.com/d1djiJaNTa.png' style={{borderRadius: '10px 10px 0 0'}}/>
        </CardMedia>
        <CardTitle
          title={<h2 className="small-spacing2">Fix SEO Problems</h2>}
          subtitle="$180 - $480 one-off fee"
          style={{paddingBottom: 12}}
        />
        <CardText style={{padding: '0 16px'}}>
          <ul className='icon-font-list'>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>
              Get your home page, products & collection pages ready for higher Google rankings, more traffic, & increased sales
            </li>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>Structure your shop for best SEO, correct issues found</li>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>
              Over 3000 Shopify stores have used this service to improve their SEO
            </li>
          </ul>
        </CardText>
        <CardActions style={{padding: 16}}>
          <Button
            label="Learn more"
            buttonType="secondary"
            href={Enum.GenerateBlimponUrl(Enum.CheckTypes.seoproblems.id, this.context.currentUser.activeCharge, this.props.source)}
            onTouchTap={() => AnalyticsUtils.learnMoreButtonClicked(JOB_TYPE)}
          />
        </CardActions>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/jobs/SEOFixesCard.js